export function isIe() {
  const userAgent = window.navigator && window.navigator.userAgent;
  const isRunningInIE = userAgent && (userAgent.indexOf('MSIE ') > -1 || userAgent.includes('Trident/7'));
  return isRunningInIE;
}
